import React from 'react';
import supplies from '@/data/utils';
import SupplyCard from '@/components/SupplyCard';

const Informaciones = () => {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Contenido principal */}
      <main className="flex-1 w-full flex flex-col items-center py-12 px-6 md:px-12">
        <h1 className="text-4xl font-bold text-blue-900 mb-8 text-center">
          Informaciones
        </h1>
        <p className="text-lg text-blue-700 text-center mb-12 max-w-3xl mx-auto">
          Aquí encontrarás información relevante, documentos y listas de útiles escolares para descargar o previsualizar.
        </p>

        <div className="w-full max-w-4xl grid gap-6">
          {supplies.map((supply) => (
            <SupplyCard key={supply.id} supply={supply} />
          ))}
        </div>
      </main>
    </div>
  );
};

export default Informaciones;
